import React from "react";
import {Route, Switch} from 'react-router-dom';
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import AlertMessage from "./components/shared/alertMessage";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons';
import { LanguageProvider } from "./components/shared/language";
import { faCheckSquare, faSearch, faFileDownload , faInfoCircle, faCloudDownloadAlt, faGlobe} from '@fortawesome/free-solid-svg-icons'


library.add(fab, faCheckSquare, faSearch, faFileDownload, faInfoCircle, faCloudDownloadAlt, faGlobe)

class IndexLogged extends React.Component {
  constructor(props) {
    super(props);
    this.state = { result: null, failed:false };
  }

  async componentDidMount(){
    await this.loggedApp()
  }

  loggedApp = async() => {

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", localStorage.getItem('token'))
    myHeaders.append("Employee", localStorage.getItem('n_number'))
  
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
  
    try{
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/query`,
        requestOptions
      );
    
      const result = await response.json();
  
      
    
      if (response.ok) {
        result.queries.map(query => query.params)
        
        this.setState({
          result: result
        });
      }else{
        this.setState({
          failed: true
        });
      }
  
    }
    catch(err){
      return(
        <div class="contenedor-error">
            <AlertMessage
        title='Ops seems something is wrong.'
        description='Please, review the content of json files problably is any wrong with them.'
      />
        </div>);
    }
  
  }
  

  render() {
    if(this.state.result){
      return (
        <React.StrictMode>
          <BrowserRouter>
          <Switch>
            <Route path="/:appUrl?/:idUrl?" >
              <LanguageProvider>
              <App entities={this.state.result.queries}/>
              </LanguageProvider>
            </Route> 
          </Switch>
          </BrowserRouter>
            
        </React.StrictMode>
      );
    }else if(this.state.failed){
      return( <div class="contenedor-error">
                <AlertMessage
            title='Ops seems something is wrong.'
            description='Please, review the content of json files problably is any wrong with them.'
          />
            </div>);
    }else{
      return(<p>Loading...</p>);
    }
    
  }
}


//loggedApp();

export default IndexLogged;
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
